// Table cards for one restaurant location, /cards/<code>: a printable letter-size sheet of four
// cards to cut out and put in check presenters. Each card's QR code is that location's own link,
// so splits that start from a card count under its code. Nothing private here: it's what's printed.
import { checkCode } from '../api.ts';
import { app, esc, logo, target } from '../dom.ts';
import { titled, wordmarkHtml } from '../../brand.ts';
import { onLeave } from '../router.ts';
import { errorScreen } from './shared.ts';

const card = (code: string, venue: string) => `
  <div class="tc">
    <div class="tc-top">Splitting the check?</div>
    <img class="tc-qr" src="/card-qr/${esc(code)}.svg" alt="QR code for ${esc(venue)}">
    <div class="tc-how">Scan it. One person pays the bill, and everyone pays them back for exactly what they had.</div>
    <div class="tc-small">No app. Takes about two minutes.</div>
    <div class="tc-foot"><span class="tc-brand">${wordmarkHtml()}</span><span>${esc(venue)}</span></div>
  </div>`;

export function cardsView(code: string): void {
  document.title = titled('Table cards');
  app.classList.add('wide', 'print-sheet');
  onLeave(() => app.classList.remove('wide', 'print-sheet'));
  app.innerHTML = `<div class="bar">${logo}<span>Table cards</span></div><div class="body"><p class="loading">Loading…</p></div>`;
  checkCode(code).then((c) => {
    if (!c.venue) throw new Error("That code isn't a table card.");
    app.innerHTML = `
      <div class="bar no-print">${logo}<span>Table cards · ${esc(c.code)}</span></div>
      <div class="body no-print stack" style="max-width:640px">
        <h1 class="h" style="margin:0">Table cards for ${esc(c.venue)}</h1>
        <p class="sub" style="margin:0">Four cards to a page. Print on card stock, cut along the lines, and put one in each check presenter. Every scan counts under ${esc(c.code)}.</p>
        <button class="btn" data-act="print">Print</button>
        <div class="sub amt" style="word-break:break-all;font-size:13px">${esc(c.link || '')}</div>
      </div>
      <div class="tc-sheet">${Array.from({ length: 4 }, () => card(c.code, c.venue || '')).join('')}</div>`;
    app.onclick = (e) => { if (target(e, '[data-act=print]')) window.print(); };
  }).catch((err: Error) => errorScreen(err.message));
}
